import armadietto from '../images/armadietto.jpg'

function Armadietto() {
	return (
		<center>
		<img src={armadietto} alt="armadietto"/>
		</center>
	)
}

export default Armadietto;